import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';

import { ApiError, BaseFormList, ConfigService, MessageService } from '../../../core';
import { ConfigCotacaoItemFormularioIndicador, getItemFormularioIndicador } from '../../configuracoes/app/cotacao';
import { UnidadeNegocioLinhaProducao } from './unidade-negocio-linha-producao';
import { LinhaProducao, LinhaProducaoCrudHttpService } from '../../linha-producao';

@Component({
    selector: 'sgt-unidade-negocio-linha-producao',
    templateUrl: './unidade-negocio-linha-producao.component.html',
    styleUrls: ['./unidade-negocio-linha-producao.component.less']
})
export class UnidadeNegocioLinhaProducaoComponent implements BaseFormList<UnidadeNegocioLinhaProducao>, OnInit {
    @Input() nomeUnidadeNegocio = '';
    /** Se pode editar as linhas de produções */
    @Input() canEdit = true;
    /** Linhas de produções vinculadas na unidade de negócio */
    @Input() entities: UnidadeNegocioLinhaProducao[];

    linhasProducoes: LinhaProducao[];

    @ViewChildren('selectLinhaProducao') selectsLinhaProducao: QueryList<ElementRef>;

    // Formulários dos Itens da Cotação
    itensFormulariosCotacao: ConfigCotacaoItemFormularioIndicador[] = [];

    constructor(private configService: ConfigService,
                private messageService: MessageService,
                private linhaProducaoCrudHttpService: LinhaProducaoCrudHttpService) { }

    ngOnInit() {
        this.createItensFormulariosCotacao();
        this.searchLinhasProducao();
    }

    /** Cria as opções dos Formulários dos Itens da Cotação para selecionar e vincular na Unidade de Negócio e Linha de Produção */
    private createItensFormulariosCotacao(): ConfigCotacaoItemFormularioIndicador[] {
        const configCotacao = this.configService.getCotacao();
        if (!configCotacao || !configCotacao.itensFormularios) {
            return [];
        }

        this.itensFormulariosCotacao = [];
        configCotacao.itensFormularios.forEach(itemFormulario => {
            const indicador = getItemFormularioIndicador(itemFormulario.formulario);
            if (indicador) {
                this.itensFormulariosCotacao.push(indicador);
            }
        });
    }

    /** Pesquisa as Linhas de Produção ativas cadastradas */
    private searchLinhasProducao() {
        this.linhasProducoes = [];
        this.linhaProducaoCrudHttpService.search()
            .subscribe(
                entities => this.linhasProducoes = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as Linhas de Produção cadastradas', error)
            );
    }

    onChangeLinhaProducao(entity: UnidadeNegocioLinhaProducao, idLinhaProducao: number) {
        if (!entity) {
            return;
        }

        entity.idLinhaProducao = idLinhaProducao;
        entity.linhaProducao = this.linhasProducoes.find(entityFilter => entityFilter.id === idLinhaProducao);
    }

    insert() {
        const entity = new UnidadeNegocioLinhaProducao();
        this.entities.push(entity);

        setTimeout(() => this.setFocusSelectLinhaProducao(), 200);
    }

    /** Seta o foco no select da linha de produção ao inserir */
    private setFocusSelectLinhaProducao() {
        if (!this.selectsLinhaProducao) {
            return;
        }
        // Obtendo o último select para setar o foco
        const selectElement = this.selectsLinhaProducao.last;
        if (selectElement) {
            jQuery(selectElement.nativeElement).focus();
        }
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir essa Linha de Produção da Unidade de Negócio?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica as Linhas de Produção estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (!entity.idLinhaProducao) {
                continue;
            }
            const count = this.entities.filter(entityFilter => entityFilter.idLinhaProducao && entityFilter.idLinhaProducao === entity.idLinhaProducao).length;
            if (count > 1) {
                const linhaProducao = this.linhasProducoes.find(entityFilter => entityFilter.id === entity.idLinhaProducao);
                const nomeLinhaProducao = linhaProducao ? linhaProducao.nome : '';
                this.messageService.info(`A Linha de Produção ${nomeLinhaProducao} já está adicionada. Remova ou altere a Linha de Produção duplicada`, 'Não é possível adicionar duas Linhas de Produção iguais');
                return false;
            }
        }
        return true;
    }


    /** Resolve as Linhas de Porudção presentes na Unidade de Negócio */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo os itens do array que não possuirem o ID da Linha de Produção informado
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idLinhaProducao) {
                this.entities.splice(i, 1);
            }
        }
    }

}
